import { Text, Title } from "@dropbox/dig-components/typography";
import { UIIcon } from "@dropbox/dig-icons";
import { CloseLine, TargetLine } from "@dropbox/dig-icons/assets";
import { ChatDiagnosticsViewerResult } from "@mirage/mosaics/ConversationAssistant/containers/ConversationAssistantPageContent/diagnostics/ChatDiagnosticsViewerResult";
import { useConversationDiagnostics } from "@mirage/service-conversation/hooks/useConversationDiagnostics";
import { IconButtonWithTooltip } from "@mirage/shared/icons/IconButtonWithTooltip";
import classNames from "classnames";
import { memo, useState } from "react";
import styles from "./ChatDiagnosticsViewer.module.css";

export const ChatDiagnosticsViewer = memo(() => {
  const diagnostics = useConversationDiagnostics();
  const [isExpanded, setIsExpanded] = useState(false);

  if (!diagnostics?.enabled) {
    return null;
  }

  if (!isExpanded) {
    return (
      <div
        className={classNames(
          styles.ChatDiagnosticsViewerToggle,
          "meticulous-redact-recording",
        )}
      >
        <IconButtonWithTooltip
          tooltipProps={{ title: "Open Diagnostics" }}
          variant="outline"
          size="medium"
          onClick={() => setIsExpanded(true)}
        >
          <UIIcon src={TargetLine} />
        </IconButtonWithTooltip>
      </div>
    );
  }

  return (
    <div
      className={classNames(
        styles.ChatDiagnosticsViewer,
        "meticulous-redact-recording",
      )}
    >
      <div className={styles.header}>
        <Title size="small">
          Chat Diagnostics{" · "}
          <Text size="medium" color="subtle">
            {diagnostics.logs.length} logs
          </Text>
        </Title>
        <IconButtonWithTooltip
          tooltipProps={{ title: "Close" }}
          variant="borderless"
          size="medium"
          onClick={() => setIsExpanded(false)}
        >
          <UIIcon src={CloseLine} />
        </IconButtonWithTooltip>
      </div>
      <div className={styles.logs}>
        {diagnostics.logs.map((log) => (
          <ChatDiagnosticsViewerResult key={log.timestamp} result={log} />
        ))}
      </div>
    </div>
  );
});
ChatDiagnosticsViewer.displayName = "ChatDiagnosticsViewer";
